export default __webpack_public_path__ + "static/media/itempage-image-2.0f7fc75e.jpg";